var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndependentPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stay home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "2 28 32 4 62 28",
    "data-cap": "butt"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "10 30 10 60 54 60 54 30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 31,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,41A12,12,0,0,0,20,53H44A12,12,0,0,0,32,41Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndependentPatient);
export default __webpack_public_path__ + "static/media/independentPatient.728f7af824f02bdcdb6a754f4adbd87b.svg";
export { ForwardRef as ReactComponent };